/**
 * Store Locator Multi-Language Override
 * Version: 1.2.2
 * 
 *  
 * Maintained by: Rose Perl Technology
 * 4-30-26 added pt and it language support 
 * 05-04-26 added directions to dom labels 
 * 
 * PURPOSE
 * -------
 * Temporary frontend localization patch for Store Locator when native
 * app-level translation support is not yet available.
 *
 * HOW IT WORKS
 * ------------
 * 1. Detects locale from storefront signals:
 *    - URL path
 *    - URL hash
 *    - ?lang= query param
 *    - Shopify.locale
 *    - <html lang="">
 *
 * 2. Waits for SCASLSetting to become available, then merges translated
 *    UI text into that object.
 *
 * 3. Patches selected labels directly in the DOM because some rendered
 *    UI text may not come from SCASLSetting.
 *
 * 4. Observes Store Locator DOM changes so translated labels persist
 *    after dynamic re-renders.
 *
 * USAGE NOTES
 * -----------
 * - Keep this file in Shopify theme assets:
 *   assets/sl-i18n.js
 *
 * - Load it in theme.liquid before or alongside Store Locator:
 *   <script src="{{ 'sl-i18n.js' | asset_url }}" defer></script>
 *
 * - Add SCASLSetting-driven labels to TRANSLATIONS.
 * - Add directly rendered labels to DOM_LABELS and patchDomLabels().
 *
 * - Review this patch after Store Locator app updates.
 */
(function storeLocatorI18n() {
  var DEFAULT_LOCALE = "en-gb";

  /**
   * Supported locales.
   * Short language inputs are mapped to these full locale codes.
   */
  var SUPPORTED_LOCALES=["en-gb","sv-se","nb-no","de-de","pl-pl","es-es","fr-ca","it-it","pt-pt"]
  /**
   * Maps short language codes and locale variants to the supported locale.
   */
  var LOCALE_ALIASES = {
    en: "en-gb",
    "en-gb": "en-gb",
    "en-us": "en-gb",
    "en-ca": "en-gb",

    sv: "sv-se",
    "sv-se": "sv-se",

    nb: "nb-no",
    no: "nb-no",
    "nb-no": "nb-no",
    "no-no": "nb-no",

    de: "de-de",
    "de-de": "de-de",

    pl: "pl-pl",
    "pl-pl": "pl-pl",

    es: "es-es",
    "es-es": "es-es",

    fr: "fr-ca",
    "fr-ca": "fr-ca",
    "fr-fr": "fr-ca",
    "fr-be": "fr-ca",

    it:"it-it",
    "it-it":"it-it",

    pt:"pt-pt",
    "pt-pt":"pt-pt",
    "pt-br":"pt-pt"
  };

  /**
   * Translation strings merged into SCASLSetting.
   * Add new keys here when the Store Locator app exposes them through
   * the SCASLSetting configuration object.
   */
  var TRANSLATIONS = {
    "en-gb": {
      page_title: "Store Locator",
      curr_loc_text: "Current Location",
      enter_a_location_text: "Enter a location",
      radius_text: "Search Radius",
      msr_text: "Search Radius Measurement",
      find_loc_btn_text: "Find My Location",
      search_btn_text: "Search",
      filter_tags_text: "Filter by Tags",
      no_limit_text: "No Limit",
      miles_text: "Mile",
      kilometers_text: "Kilometer",
      kilometer_unit_text: "Kilometer",
      map_text: "Map",
      list_text: "List",
      view_map_btn_text: "View Map",
      more_text: "More",
      less_text: "Less",
      direction_text: "Get Directions",
      no_result_title: "No results",
      no_result_tags: "No stores found near this location.",
      location_is_disabled_alert: "Location Services Disabled",
      location_is_disabled_text:
        "Please turn on device location to use Find My Location",
      open_text: "Open",
      open_now_text: "Open now",
      opens_text: "Opens",
      closed_text: "Closed",
      closes_text: "Closes",
      closes_soon_text: "Closes soon",
      monday_text: "Monday",
      tuesday_text: "Tuesday",
      wednesday_text: "Wednesday",
      thursday_text: "Thursday",
      friday_text: "Friday",
      saturday_text: "Saturday",
      sunday_text: "Sunday",
      monday_acronym_text: "Mon",
      tuesday_acronym_text: "Tue",
      wednesday_acronym_text: "Wed",
      thursday_acronym_text: "Thu",
      friday_acronym_text: "Fri",
      saturday_acronym_text: "Sat",
      sunday_acronym_text: "Sun"
    },
"it-it":{
  page_title:"Localizzatore negozi",
  curr_loc_text:"Posizione attuale",
  enter_a_location_text:"Inserisci una posizione",
  radius_text:"Raggio di ricerca",
  msr_text:"Unità di misura",
  find_loc_btn_text:"Trova la mia posizione",
  search_btn_text:"Cerca",
  filter_tags_text:"Filtra per tag",
  no_limit_text:"Nessun limite",
  miles_text:"Miglio",
  kilometers_text:"Chilometro",
  kilometer_unit_text:"Chilometro",
  map_text:"Mappa",
  list_text:"Lista",
  view_map_btn_text:"Visualizza mappa",
  more_text:"Altro",
  less_text:"Meno",
  direction_text:"Ottieni indicazioni",
  no_result_title:"Nessun risultato",
  no_result_tags:"Nessun negozio trovato vicino a questa posizione.",
  location_is_disabled_alert:"Servizi di localizzazione disattivati",
  location_is_disabled_text:"Attiva la posizione del dispositivo per usare Trova la mia posizione",
  open_text:"Aperto",
  open_now_text:"Aperto ora",
  opens_text:"Apre",
  closed_text:"Chiuso",
  closes_text:"Chiude",
  closes_soon_text:"Chiude presto",
  monday_text:"Lunedì",
  tuesday_text:"Martedì",
  wednesday_text:"Mercoledì",
  thursday_text:"Giovedì",
  friday_text:"Venerdì",
  saturday_text:"Sabato",
  sunday_text:"Domenica",
  monday_acronym_text:"Lun",
  tuesday_acronym_text:"Mar",
  wednesday_acronym_text:"Mer",
  thursday_acronym_text:"Gio",
  friday_acronym_text:"Ven",
  saturday_acronym_text:"Sab",
  sunday_acronym_text:"Dom"
},
"pt-pt":{
  page_title:"Localizador de lojas",
  curr_loc_text:"Localização atual",
  enter_a_location_text:"Insira uma localização",
  radius_text:"Raio de pesquisa",
  msr_text:"Unidade de medida",
  find_loc_btn_text:"Encontrar minha localização",
  search_btn_text:"Pesquisar",
  filter_tags_text:"Filtrar por tags",
  no_limit_text:"Sem limite",
  miles_text:"Milha",
  kilometers_text:"Quilómetro",
  kilometer_unit_text:"Quilómetro",
  map_text:"Mapa",
  list_text:"Lista",
  view_map_btn_text:"Ver mapa",
  more_text:"Mais",
  less_text:"Menos",
  direction_text:"Obter direções",
  no_result_title:"Sem resultados",
  no_result_tags:"Nenhuma loja encontrada perto desta localização.",
  location_is_disabled_alert:"Serviços de localização desativados",
  location_is_disabled_text:"Ative a localização do dispositivo para usar Encontrar minha localização",
  open_text:"Aberto",
  open_now_text:"Aberto agora",
  opens_text:"Abre",
  closed_text:"Fechado",
  closes_text:"Fecha",
  closes_soon_text:"Fecha em breve",
  monday_text:"Segunda-feira",
  tuesday_text:"Terça-feira",
  wednesday_text:"Quarta-feira",
  thursday_text:"Quinta-feira",
  friday_text:"Sexta-feira",
  saturday_text:"Sábado",
  sunday_text:"Domingo",
  monday_acronym_text:"Seg",
  tuesday_acronym_text:"Ter",
  wednesday_acronym_text:"Qua",
  thursday_acronym_text:"Qui",
  friday_acronym_text:"Sex",
  saturday_acronym_text:"Sáb",
  sunday_acronym_text:"Dom"
},
    "fr-ca": {
      page_title: "Trouver une boutique",
      curr_loc_text: "Emplacement actuel",
      enter_a_location_text: "Entrez une adresse",
      radius_text: "Rayon de recherche",
      msr_text: "Unité de mesure",
      find_loc_btn_text: "Me localiser",
      search_btn_text: "Rechercher",
      filter_tags_text: "Filtrer par tags",
      no_limit_text: "Sans limite",
      miles_text: "Mille",
      kilometers_text: "Kilomètre",
      kilometer_unit_text: "Kilomètre",
      map_text: "Carte",
      list_text: "Liste",
      view_map_btn_text: "Voir la carte",
      more_text: "Plus",
      less_text: "Moins",
      direction_text: "Obtenir l'itinéraire",
      no_result_title: "Aucun résultat",
      no_result_tags: "Aucun magasin trouvé près de cet endroit.",
      location_is_disabled_alert: "Services de localisation désactivés",
      location_is_disabled_text:
        "Veuillez activer la localisation de votre appareil pour utiliser Me localiser",
      open_text: "Ouvert",
      open_now_text: "Ouvert maintenant",
      opens_text: "Ouvre",
      closed_text: "Fermé",
      closes_text: "Ferme",
      closes_soon_text: "Ferme bientôt",
      monday_text: "Lundi",
      tuesday_text: "Mardi",
      wednesday_text: "Mercredi",
      thursday_text: "Jeudi",
      friday_text: "Vendredi",
      saturday_text: "Samedi",
      sunday_text: "Dimanche",
      monday_acronym_text: "Lun",
      tuesday_acronym_text: "Mar",
      wednesday_acronym_text: "Mer",
      thursday_acronym_text: "Jeu",
      friday_acronym_text: "Ven",
      saturday_acronym_text: "Sam",
      sunday_acronym_text: "Dim"
    },

    "sv-se": {
      page_title: "Butikslokalisering",
      curr_loc_text: "Nuvarande plats",
      enter_a_location_text: "Ange en plats",
      radius_text: "Sökradie",
      msr_text: "Måttenhet för sökradie",
      find_loc_btn_text: "Hitta min plats",
      search_btn_text: "Sök",
      filter_tags_text: "Filtrera efter taggar",
      no_limit_text: "Ingen gräns",
      miles_text: "Mil",
      kilometers_text: "Kilometer",
      kilometer_unit_text: "Kilometer",
      map_text: "Karta",
      list_text: "Lista",
      view_map_btn_text: "Visa karta",
      more_text: "Mer",
      less_text: "Mindre",
      direction_text: "Få vägbeskrivning",
      no_result_title: "Inga resultat",
      no_result_tags: "Inga butiker hittades nära denna plats.",
      location_is_disabled_alert: "Platstjänster är inaktiverade",
      location_is_disabled_text:
        "Aktivera enhetens plats för att använda Hitta min plats",
      open_text: "Öppet",
      open_now_text: "Öppet nu",
      opens_text: "Öppnar",
      closed_text: "Stängt",
      closes_text: "Stänger",
      closes_soon_text: "Stänger snart",
      monday_text: "Måndag",
      tuesday_text: "Tisdag",
      wednesday_text: "Onsdag",
      thursday_text: "Torsdag",
      friday_text: "Fredag",
      saturday_text: "Lördag",
      sunday_text: "Söndag",
      monday_acronym_text: "Mån",
      tuesday_acronym_text: "Tis",
      wednesday_acronym_text: "Ons",
      thursday_acronym_text: "Tor",
      friday_acronym_text: "Fre",
      saturday_acronym_text: "Lör",
      sunday_acronym_text: "Sön"
    },

    "nb-no": {
      page_title: "Butikklokalisering",
      curr_loc_text: "Nåværende posisjon",
      enter_a_location_text: "Skriv inn et sted",
      radius_text: "Søkeradius",
      msr_text: "Måleenhet for søkeradius",
      find_loc_btn_text: "Finn min posisjon",
      search_btn_text: "Søk",
      filter_tags_text: "Filtrer etter tagger",
      no_limit_text: "Ingen grense",
      miles_text: "Mil",
      kilometers_text: "Kilometer",
      kilometer_unit_text: "Kilometer",
      map_text: "Kart",
      list_text: "Liste",
      view_map_btn_text: "Vis kart",
      more_text: "Mer",
      less_text: "Mindre",
      direction_text: "Få veibeskrivelse",
      no_result_title: "Ingen resultater",
      no_result_tags: "Ingen butikker ble funnet nær dette stedet.",
      location_is_disabled_alert: "Posisjonstjenester deaktivert",
      location_is_disabled_text:
        "Slå på enhetens posisjon for å bruke Finn min posisjon",
      open_text: "Åpen",
      open_now_text: "Åpen nå",
      opens_text: "Åpner",
      closed_text: "Stengt",
      closes_text: "Stenger",
      closes_soon_text: "Stenger snart",
      monday_text: "Mandag",
      tuesday_text: "Tirsdag",
      wednesday_text: "Onsdag",
      thursday_text: "Torsdag",
      friday_text: "Fredag",
      saturday_text: "Lørdag",
      sunday_text: "Søndag",
      monday_acronym_text: "Man",
      tuesday_acronym_text: "Tir",
      wednesday_acronym_text: "Ons",
      thursday_acronym_text: "Tor",
      friday_acronym_text: "Fre",
      saturday_acronym_text: "Lør",
      sunday_acronym_text: "Søn"
    },

    "de-de": {
      page_title: "Filialsuche",
      curr_loc_text: "Aktueller Standort",
      enter_a_location_text: "Ort eingeben",
      radius_text: "Suchradius",
      msr_text: "Einheit für Suchradius",
      find_loc_btn_text: "Meinen Standort finden",
      search_btn_text: "Suchen",
      filter_tags_text: "Nach Tags filtern",
      no_limit_text: "Keine Begrenzung",
      miles_text: "Meile",
      kilometers_text: "Kilometer",
      kilometer_unit_text: "Kilometer",
      map_text: "Karte",
      list_text: "Liste",
      view_map_btn_text: "Karte anzeigen",
      more_text: "Mehr",
      less_text: "Weniger",
      direction_text: "Route anzeigen",
      no_result_title: "Keine Ergebnisse",
      no_result_tags: "Keine Geschäfte in der Nähe dieses Ortes gefunden.",
      location_is_disabled_alert: "Standortdienste deaktiviert",
      location_is_disabled_text:
        "Bitte aktivieren Sie den Standort Ihres Geräts, um Meinen Standort finden zu verwenden",
      open_text: "Geöffnet",
      open_now_text: "Jetzt geöffnet",
      opens_text: "Öffnet",
      closed_text: "Geschlossen",
      closes_text: "Schließt",
      closes_soon_text: "Schließt bald",
      monday_text: "Montag",
      tuesday_text: "Dienstag",
      wednesday_text: "Mittwoch",
      thursday_text: "Donnerstag",
      friday_text: "Freitag",
      saturday_text: "Samstag",
      sunday_text: "Sonntag",
      monday_acronym_text: "Mo",
      tuesday_acronym_text: "Di",
      wednesday_acronym_text: "Mi",
      thursday_acronym_text: "Do",
      friday_acronym_text: "Fr",
      saturday_acronym_text: "Sa",
      sunday_acronym_text: "So"
    },

    "pl-pl": {
      page_title: "Lokalizator sklepów",
      curr_loc_text: "Bieżąca lokalizacja",
      enter_a_location_text: "Wpisz lokalizację",
      radius_text: "Promień wyszukiwania",
      msr_text: "Jednostka promienia wyszukiwania",
      find_loc_btn_text: "Znajdź moją lokalizację",
      search_btn_text: "Szukaj",
      filter_tags_text: "Filtruj według tagów",
      no_limit_text: "Bez limitu",
      miles_text: "Mila",
      kilometers_text: "Kilometr",
      kilometer_unit_text: "Kilometr",
      map_text: "Mapa",
      list_text: "Lista",
      view_map_btn_text: "Pokaż mapę",
      more_text: "Więcej",
      less_text: "Mniej",
      direction_text: "Wyznacz trasę",
      no_result_title: "Brak wyników",
      no_result_tags: "Nie znaleziono sklepów w pobliżu tej lokalizacji.",
      location_is_disabled_alert: "Usługi lokalizacji wyłączone",
      location_is_disabled_text:
        "Włącz lokalizację urządzenia, aby użyć opcji Znajdź moją lokalizację",
      open_text: "Otwarte",
      open_now_text: "Otwarte teraz",
      opens_text: "Otwiera",
      closed_text: "Zamknięte",
      closes_text: "Zamyka",
      closes_soon_text: "Wkrótce zamyka",
      monday_text: "Poniedziałek",
      tuesday_text: "Wtorek",
      wednesday_text: "Środa",
      thursday_text: "Czwartek",
      friday_text: "Piątek",
      saturday_text: "Sobota",
      sunday_text: "Niedziela",
      monday_acronym_text: "Pon",
      tuesday_acronym_text: "Wt",
      wednesday_acronym_text: "Śr",
      thursday_acronym_text: "Czw",
      friday_acronym_text: "Pt",
      saturday_acronym_text: "Sob",
      sunday_acronym_text: "Nd"
    },

    "es-es": {
      page_title: "Localizador de tiendas",
      curr_loc_text: "Ubicación actual",
      enter_a_location_text: "Introduce una ubicación",
      radius_text: "Radio de búsqueda",
      msr_text: "Unidad de medida del radio",
      find_loc_btn_text: "Encontrar mi ubicación",
      search_btn_text: "Buscar",
      filter_tags_text: "Filtrar por etiquetas",
      no_limit_text: "Sin límite",
      miles_text: "Milla",
      kilometers_text: "Kilómetro",
      kilometer_unit_text: "Kilómetro",
      map_text: "Mapa",
      list_text: "Lista",
      view_map_btn_text: "Ver mapa",
      more_text: "Más",
      less_text: "Menos",
      direction_text: "Obtener indicaciones",
      no_result_title: "Sin resultados",
      no_result_tags: "No se encontraron tiendas cerca de esta ubicación.",
      location_is_disabled_alert: "Servicios de ubicación desactivados",
      location_is_disabled_text:
        "Activa la ubicación del dispositivo para usar Encontrar mi ubicación",
      open_text: "Abierto",
      open_now_text: "Abierto ahora",
      opens_text: "Abre",
      closed_text: "Cerrado",
      closes_text: "Cierra",
      closes_soon_text: "Cierra pronto",
      monday_text: "Lunes",
      tuesday_text: "Martes",
      wednesday_text: "Miércoles",
      thursday_text: "Jueves",
      friday_text: "Viernes",
      saturday_text: "Sábado",
      sunday_text: "Domingo",
      monday_acronym_text: "Lun",
      tuesday_acronym_text: "Mar",
      wednesday_acronym_text: "Mié",
      thursday_acronym_text: "Jue",
      friday_acronym_text: "Vie",
      saturday_acronym_text: "Sáb",
      sunday_acronym_text: "Dom"
    }
  };

  /**
   * Labels patched directly into the rendered DOM.
   * Add entries here when visible labels are not controlled by SCASLSetting.
   */
 var DOM_LABELS = {
  "en-gb": {
    phone_label: "Phone Number",
    email_label: "Email",
    operating_hours_label: "Operating Hours",
    where_to_buy_button_text: "Where to Buy",
    find_online_button_text: "Find Online",
    direction_button_text: "Directions"
  },

  "it-it": {
    phone_label: "Telefono",
    email_label: "Email",
    operating_hours_label: "Orari di apertura",
    where_to_buy_button_text: "Dove acquistare",
    find_online_button_text: "Trova online", 
    direction_button_text: "Indicazioni"
  },

  "pt-pt": {
    phone_label: "Telefone",
    email_label: "Email",
    operating_hours_label: "Horário de funcionamento",
    where_to_buy_button_text: "Onde comprar",
    find_online_button_text: "Encontrar online",
    direction_button_text: "Direções"
  },

  "fr-ca": {
    phone_label: "Numéro de téléphone",
    email_label: "Courriel",
    operating_hours_label: "Heures d'ouverture",
    where_to_buy_button_text: "Où acheter",
    find_online_button_text: "Trouver en ligne",
    direction_button_text: "Itinéraire"
  },

  "sv-se": {
    phone_label: "Telefonnummer",
    email_label: "E-post",
    operating_hours_label: "Öppettider",
    where_to_buy_button_text: "Var man kan köpa",
    find_online_button_text: "Hitta online",
    direction_button_text: "Vägbeskrivning"
  },

  "nb-no": {
    phone_label: "Telefonnummer",
    email_label: "E-post",
    operating_hours_label: "Åpningstider",
    where_to_buy_button_text: "Hvor du kan kjøpe",
    find_online_button_text: "Finn på nett",
    direction_button_text: "Veibeskrivelse"
  },

  "de-de": {
    phone_label: "Telefonnummer",
    email_label: "E-Mail",
    operating_hours_label: "Öffnungszeiten",
    where_to_buy_button_text: "Bezugsquellen",
    find_online_button_text: "Online finden",
    direction_button_text: "Route"
  },

  "pl-pl": {
    phone_label: "Numer telefonu",
    email_label: "E-mail",
    operating_hours_label: "Godziny otwarcia",
    where_to_buy_button_text: "Gdzie kupić",
    find_online_button_text: "Znajdź online",
    direction_button_text: "Wskazówki dojazdu"
  },

  "es-es": {
    phone_label: "Número de teléfono",
    email_label: "Correo electrónico",
    operating_hours_label: "Horario de atención",
    where_to_buy_button_text: "Dónde comprar",
    find_online_button_text: "Encontrar en línea",
    direction_button_text: "Indicaciones"
  }
};

  function normalizeLocale(input) {
    if (!input) return null;

    var normalized = String(input).toLowerCase().trim();
    return LOCALE_ALIASES[normalized] || null;
  }

  function localeFromPath(pathname) {
    var match = pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(\/|$)/i);
    return match ? normalizeLocale(match[1]) : null;
  }

  function localeFromHash(hash) {
    var cleaned = String(hash || "").replace(/^#/, "");
    return normalizeLocale(cleaned);
  }

  function localeFromQuery(search) {
    var params = new URLSearchParams(search);
    return normalizeLocale(params.get("lang"));
  }

  function localeFromShopify() {
    return typeof Shopify !== "undefined" && Shopify.locale
      ? normalizeLocale(Shopify.locale)
      : null;
  }

  function localeFromHtmlLang() {
    var htmlLang = document.documentElement.lang || "";
    return normalizeLocale(htmlLang);
  }

  /**
   * Detect the active locale using multiple storefront signals.
   * Falls back to DEFAULT_LOCALE if no supported value is found.
   */
  function detectLocale() {
    return (
      localeFromPath(window.location.pathname) ||
      localeFromHash(window.location.hash) ||
      localeFromQuery(window.location.search) ||
      localeFromShopify() ||
      localeFromHtmlLang() ||
      DEFAULT_LOCALE
    );
  }

  /**
   * Merge locale strings into SCASLSetting.
   */
  function applyTranslations(translations) {
    if (typeof window.SCASLSetting === "undefined") {
      return false;
    }

    Object.assign(window.SCASLSetting, translations);
    return true;
  }

  /**
   * Patch directly rendered DOM labels.
   * Update selectors here if Store Locator markup changes.
   */
  function patchDomLabels(labels) {
    if (!labels) return;

    if (labels.phone_label) {
      document.querySelectorAll("#scasl-phone-label").forEach(function (el) {
        if (el.textContent !== labels.phone_label) {
          el.textContent = labels.phone_label;
        }
      });
    }
// Directions button patch
if (labels.direction_button_text) {
  document.querySelectorAll(".direction-wrapper, .direction-wrapper span").forEach(function(el) {
    if (el.textContent !== labels.direction_button_text) {
      el.textContent = labels.direction_button_text;
    }
  });
}
    if (labels.email_label) {
      document.querySelectorAll("#scasl-email-label").forEach(function (el) {
        if (el.textContent !== labels.email_label) {
          el.textContent = labels.email_label;
        }
      });
    }

    if (labels.operating_hours_label) {
      document
        .querySelectorAll("#scasl-operating-hours-label")
        .forEach(function (el) {
          if (el.textContent !== labels.operating_hours_label) {
            el.textContent = labels.operating_hours_label;
          }
        });
    }
  //  Button mapping (target inner <span>)
  var BUTTON_MAP = {
    "#wtb-btn span": "where_to_buy_button_text",
    "#fo-btn span": "find_online_button_text"
  };

  Object.keys(BUTTON_MAP).forEach(function(selector) {
    var key = BUTTON_MAP[selector];

    if (labels[key]) {
      document.querySelectorAll(selector).forEach(function(el) {
        if (el.textContent !== labels[key]) {
          el.textContent = labels[key];
        }
      });
    }
  });
  }

  /**
   * Observe Store Locator DOM changes so translated labels persist after re-renders.
   */
  function observeDom(labels) {
    var container =
      document.querySelector("#scasl-app-container") || document.body;

    var observer = new MutationObserver(function () {
      patchDomLabels(labels);
    });

    observer.observe(container, {
      childList: true,
      subtree: true
    });

    patchDomLabels(labels);
  }

  /**
   * Initialize localization flow.
   */
  function init() {
    var locale = detectLocale();
    var translations = TRANSLATIONS[locale] || TRANSLATIONS[DEFAULT_LOCALE];
    var domLabels = DOM_LABELS[locale] || DOM_LABELS[DEFAULT_LOCALE];

    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;

      if (applyTranslations(translations)) {
        clearInterval(interval);
        return;
      }

      if (attempts >= 50) {
        clearInterval(interval);
        console.warn(
          "[sl-i18n] SCASLSetting not found after 50 attempts. Patch not applied."
        );
      }
    }, 100);

    observeDom(domLabels);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();